import { Diagnostic } from '@ionic-native/Diagnostic';
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicModule } from 'ionic-angular';
import { ShapeDrawComponent } from './components/shape-draw/shape-draw';
import { ThfIconComponent } from './components/thf-icon/thf-icon';
import { TotvsTranslatePipe } from './pipes/totvs-translate-pipe/totvs-translate-pipe';
import { MapProvider } from './providers/map';
import { TotvsNotificationProvider } from './providers/totvs-notification-provider';
import { TotvsTranslateProvider } from './providers/totvs-translate-provider';

// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        // Only if you use elements like ion-content, ion-xyz...
        IonicModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })
    ],
    declarations: [
        // declare all components that your module uses
        ShapeDrawComponent,
        ThfIconComponent,
        TotvsTranslatePipe
    ],
    providers: [
        Diagnostic
    ],
    exports: [
        // export the component(s) that you want others to be able to use
        ShapeDrawComponent,
        ThfIconComponent,
        TotvsTranslatePipe
    ]
})
export class TotvsAgroCoreMobileModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TotvsAgroCoreMobileModule,
            providers: [TotvsNotificationProvider, MapProvider, TotvsTranslateProvider],
        };
    }
}